// In-memory storage for server - PER REQUEST
let memoryToken: string | null = null;

export class ServerTokenManager {
  // Get token from server storage
  static getToken(): string | null {
    return memoryToken;
  }

  // Set token in server storage (memory only)
  static setToken(token: string): void {
    memoryToken = token;
  }

  // Get the token that was captured during server requests
  static getLatestToken(): string | null {
    return memoryToken;
  }

  // Clear token from server storage
  static clearToken(): void {
    memoryToken = null;
  }

  // Check if token exists
  static hasToken(): boolean {
    return !!memoryToken;
  }

  // Reset memory token (call this at start of new request if needed)
  static reset(): void {
    memoryToken = null;
  }
}
